export const RouterPaths = {
  insightsHome: '/insights',
  summaryOverview: '/insights/summary/root',
  insightsSummary: '/insights/summary/:insight_type',
  contentCategories: '/insights/summary/content_categories',
  insightsSummaryDetail: '/insights/detail/:insight_type/:id',
  digger: '/digger',
  custom: '/custom_insights',
  customTables: '/custom_insights/custom_tables',
  templates: '/templates',
  templateSummary: '/templates/:id',
  templateSummaryDetail: '/templates/:id/:detail',
} as const;

export const PathConstants = {
  pathsWithoutFilter: [
    '/insights/summary/root',
    '/templates',
    '/custom_insights',
    '/custom_insights/custom_tables',
  ],
  pathsWithoutXlsExport: ['/insights/summary/root', '/templates'],
  pathsWithJsonExport: ['/digger'],
  pathsWithoutPptxOrPdfExport: ['/digger', '/templates'],
  pathsWithoutHtmlExport: [
    '/digger',
    '/templates',
    '/custom_insights',
    '/custom_insights/custom_tables',
  ],
} as const;
